import { breakpoints } from './breakpoints.js';

export const styledComponentsTheme = {
  breakpoints: Object.assign(
    [],
    [
      breakpoints.sm,
      breakpoints.md,
      breakpoints.lg,
      breakpoints.xl,
      breakpoints.xxl,
    ],
    breakpoints,
  ),
  colors: {
    alertError: 'var(--color-alertError)',
    alertInformational: 'var(--color-alertInformational)',
    alertSuccess: 'var(--color-alertSuccess)',
    alertWarning: 'var(--color-alertWarning)',
    brandBlack: 'var(--color-brandBlack)',
    brandBlue: 'var(--color-brandBlue)',
    brandGreen: 'var(--color-brandGreen)',
    brandLightGray: 'var(--color-brandLightGray)',
    brandOrange: 'var(--color-brandOrange)',
    brandPurple: 'var(--color-brandPurple)',
    brandSalmon: 'var(--color-brandSalmon)',
    brandWatermelon: 'var(--color-brandWatermelon)',
    brandWhite: 'var(--color-brandWhite)',
    brandYellow: 'var(--color-brandYellow)',
    gray10: 'var(--color-gray10)',
    gray20: 'var(--color-gray20)',
    gray30: 'var(--color-gray30)',
    gray40: 'var(--color-gray40)',
    gray50: 'var(--color-gray50)',
    gray60: 'var(--color-gray60)',
    gray70: 'var(--color-gray70)',
    gray80: 'var(--color-gray80)',
    gray90: 'var(--color-gray90)',
    green10: 'var(--color-green10)',
    green20: 'var(--color-green20)',
    green30: 'var(--color-green30)',
    green40: 'var(--color-green40)',
    green50: 'var(--color-green50)',
    green60: 'var(--color-green60)',
    green70: 'var(--color-green70)',
    overlay10: 'var(--color-overlay10)',
    overlay20: 'var(--color-overlay20)',
    red10: 'var(--color-red10)',
    red20: 'var(--color-red20)',
    red30: 'var(--color-red30)',
    red40: 'var(--color-red40)',
    red50: 'var(--color-red50)',
    red60: 'var(--color-red60)',
    red70: 'var(--color-red70)',
    socialInvision: 'var(--color-socialInvision)',
    socialReact: 'var(--color-socialReact)',
    socialTwitter: 'var(--color-socialTwitter)',
    uiBlackDisabled: 'var(--color-uiBlackDisabled)',
    uiBlackHighEmphasis: 'var(--color-uiBlackHighEmphasis)',
    uiBlackMediumEmphasis: 'var(--color-uiBlackMediumEmphasis)',
    uiErrorFocus: 'var(--color-uiErrorFocus)',
    uiErrorRegular: 'var(--color-uiErrorRegular)',
    uiFilterGreen: 'var(--color-uiFilterGreen)',
    uiInputBackground: 'var(--color-uiInputBackground)',
    uiSelected: 'var(--color-uiSelected)',
    white10: 'var(--color-white10)',
    white20: 'var(--color-white20)',
    white30: 'var(--color-white30)',
    white40: 'var(--color-white40)',
    yellow10: 'var(--color-yellow10)',
    yellow20: 'var(--color-yellow20)',
    yellow30: 'var(--color-yellow30)',
    yellow40: 'var(--color-yellow40)',
    yellow50: 'var(--color-yellow50)',
    yellow60: 'var(--color-yellow60)',
    yellow70: 'var(--color-yellow70)',
  },
  fonts: {
    body: 'var(--font-body)',
    headline: 'var(--font-headline)',
    mono: 'var(--font-mono)',
    signature: 'var(--font-signature)',
  },
  fontSizes: [
    '10px',
    '12px',
    '14px',
    '16px',
    '19px',
    '23px',
    '34px',
    '60px',
    '72px',
    '93px',
  ],
  fontWeights: {
    bold: '700',
    extraBold: '800',
    medium: '500',
    regular: '400',
    semiBold: '600',
  },
  lineHeights: [
    '16px',
    '20px',
    '24px',
    '28px',
    '32px',
    '40px',
    '44px',
    '60px',
    '72px',
    '120px',
  ],
  mediaQueries: {
    dark: '@media (prefers-color-scheme: dark)',
    lg: '@media screen and (min-width: 992px)',
    md: '@media screen and (min-width: 768px)',
    reduceMotion: '@media (prefers-reduced-motion)',
    sm: '@media screen and (min-width: 576px)',
    xl: '@media screen and (min-width: 1200px)',
    xxl: '@media screen and (min-width: 1440px)',
  },
  textStyles: {
    bodyRegular: {
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '1.5',
    },
    bodySmall: {
      fontSize: '14px',
      fontWeight: '400',
      letterSpacing: '0.15px',
      lineHeight: '1.429',
    },
    captionBold: {
      fontSize: '12px',
      fontWeight: '600',
      letterSpacing: '0.15px',
      lineHeight: '1.333',
    },
    captionRegular: {
      fontSize: '12px',
      fontWeight: '400',
      letterSpacing: '0.15px',
      lineHeight: '1.333',
    },
    codeBlockRegular: {
      fontFamily: '$mono',
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '1.5',
    },
    headingH1: {
      fontFamily: '$headline',
      fontSize: '93px',
      fontWeight: '700',
      letterSpacing: '-2.5px',
      lineHeight: '1.29',
    },
    headingH2: {
      fontFamily: '$headline',
      fontSize: '58px',
      fontWeight: '700',
      letterSpacing: '-1px',
      lineHeight: '1.241',
    },
    headingH3: {
      fontFamily: '$headline',
      fontSize: '48px',
      fontWeight: '700',
      letterSpacing: '-0.75px',
      lineHeight: '1.25',
    },
    headingH4: {
      fontFamily: '$headline',
      fontSize: '34px',
      fontWeight: '700',
      letterSpacing: '-0.5px',
      lineHeight: '1.294',
    },
    headingH5: {
      fontFamily: '$headline',
      fontSize: '23px',
      fontWeight: '600',
      letterSpacing: '-0.25px',
      lineHeight: '1.391',
    },
    headingH6: {
      fontFamily: '$headline',
      fontSize: '19px',
      fontWeight: '600',
      lineHeight: '1.474',
    },
    overlineBold: {
      fontSize: '10px',
      fontWeight: '600',
      letterSpacing: '1.2px',
      lineHeight: '1.6',
      textTransform: 'uppercase',
    },
    overlineRegular: {
      fontSize: '10px',
      fontWeight: '400',
      letterSpacing: '1.2px',
      lineHeight: '1.6',
      textTransform: 'uppercase',
    },
    subtitleRegular: {
      fontSize: '16px',
      fontWeight: '600',
      letterSpacing: '-0.15px',
      lineHeight: '1.5',
    },
    subtitleSmall: {
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '1.429',
    },
  },
} as const;
